import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiClient from '../../services/axios';

export const placeBet = createAsyncThunk(
  'bet/postBet',
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiClient.request({
        url: process.env.REACT_APP_BET_ROUTE,
        method: 'POST',
        data
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);
const betSlice = createSlice({
  name: "bet",
  initialState: null,
  reducers: {
    clearBet() {
      // no active bet
      return null;
    },
    setActiveBet(state, action) {
      // used when we already have an active ticket from login
      state = action.payload;
      return state;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(placeBet.fulfilled, (state, action) => {
        const payload = action.payload;

        // If platform returned error (Status !== 1), do NOT keep bet in store
        if (!payload || payload.Status !== 1) {
          return null;
        }

        return {
          ...payload,
          loading: false,
        };
      })
      .addCase(placeBet.rejected, () => {
        // On transport / network error also ensure there's no active bet
        return null;
      });
  } 
});

export const { clearBet, setActiveBet } = betSlice.actions;
export default betSlice.reducer;
